import { Rest, Product, PayOpt, NfProduct, PayMethod, Nfce } from "./types";

export function toBrl(value: number | string) {
  return (Number(value) / 100).toFixed(2).replace(/\./g, ",");
}

export function fromBrl(value: string) {
  return Number(value.replace(/,/g, ".")) * 100;
}

export function fromPoster(value: Rest) {
  let items: Array<NfProduct> = [];

  //sorry x=v-(d*v/100)
  let remaining = Math.round(
    (((100 *
      (fromBrl(value.payed_cash) +
        fromBrl(value.payed_card) -
        fromBrl(value.tip_sum))) /
      (value.discount * -1 + 100)) *
      value.discount) /
      100
  );

  value.products.forEach((e, i, arr) => {
    let des = Math.round((value.discount * fromBrl(e.product_price)) / 100);

    items.push({
      numero_item: 0,
      codigo_produto: e.product_id,
      descricao: e.product_name,
      valor_desconto: arr.length == i + 1 ? remaining / 100 : des / 100,
      quantidade_comercial: e.num,
      quantidade_tributavel: e.num,
      valor_unitario_comercial: fromBrl(e.product_price) / e.num / 100,
      valor_unitario_tributavel: fromBrl(e.product_price) / e.num / 100,
      valor_bruto: fromBrl(e.product_price) / 100,
      cfop: e.cfop,
      codigo_ncm: e.ncm.toString(),
      icms_situacao_tributaria: e.cson,
      unidade_comercial: "un",
      icms_origem: 0,
      unidade_tributavel: "un",
      pis_situacao_tributaria: 99,
      cofins_situacao_tributaria: 99,
      icms_modalidade_base_calculo: 0,
    });
    remaining -= des;
  });
  return items;
}
